import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '¿Es seguro para mascotas y niños?',
  answer: 'Sí, utilizamos productos de última generación aprobados por ANMAT, seguros para toda la familia y mascotas una vez seco el producto.'
}, {
  question: '¿El tratamiento resuelve la plaga desde el origen?',
  answer: 'Sí, el tratamiento está enfocado en eliminar la plaga desde su origen, actuando sobre los focos donde se desarrolla y cortando su ciclo de reproducción.\n\nAdemás, se aplica con productos que generan una protección en el ambiente, ayudando a prevenir nuevas apariciones.'
}, {
  question: '¿Tengo que irme de mi casa?',
  answer: 'En la mayoría de los casos no es necesario. Te indicamos las precauciones específicas según el servicio.'
}, {
  question: '¿Hacen factura?',
  answer: 'Sí, emitimos factura C por el momento.'
}, {
  question: '¿Cubren toda Rosario?',
  answer: 'Sí, cubrimos Rosario y localidades cercanas como Funes, Roldán, Pérez, Granadero Baigorria y más.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="bg-mobal-white py-20" data-id="element-105">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-106">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-12" data-id="element-107">
          <h2 className="text-3xl md:text-5xl font-heading font-black text-mobal-black mb-4" data-id="element-108">
            PREGUNTAS FRECUENTES
          </h2>
          <div className="w-24 h-1 bg-mobal-green mx-auto" data-id="element-109"></div>
        </motion.div>

        <div className="max-w-3xl mx-auto" data-id="element-110">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.1
        }} className="mb-4" data-id="element-111">
              <button onClick={() => toggleFaq(index)} className={`w-full flex items-center justify-between p-5 md:p-6 text-left rounded-lg transition-colors ${openIndex === index ? 'bg-mobal-black text-mobal-white' : 'bg-gray-50 text-mobal-black hover:bg-gray-100'}`} aria-expanded={openIndex === index} data-id="element-112">
                <span className="font-heading font-bold text-lg pr-4" data-id="element-113">
                  {faq.question}
                </span>
                <ChevronDown className={`w-6 h-6 flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'text-mobal-green rotate-180' : 'text-gray-400'}`} data-id="element-114" />
              </button>

              <AnimatePresence data-id="element-115">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-116">
                    <div className="p-5 md:p-6 bg-white border border-t-0 border-gray-100 rounded-b-lg text-gray-700 font-body text-lg leading-relaxed whitespace-pre-line" data-id="element-117">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}